import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

export const Container = styled.main`
  position: relative;
`;

export const Section = styled.section`
  position: relative;
`;

export const InnerSection = styled.div`
  position: relative;
  max-width: 500px;
  padding: 2rem;
`;

export const AccordionContainer = styled.div`
  font-family: Roboto;
`;

export const AccordionInner = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid black;
  border-radius: 4px;
`;

export const AccordionItem = styled.div`
`;

export const AccordionTitle = styled.div`
  margin: 0;
  height: 30px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: ${C.DARK_GRAY};
  display: flex;
  align-items: center;
  padding-left: 20px;
`;

export const Title = styled.div`
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #0f1318;
  padding-top: 3px;
`;

export const AccordionBody = styled.div`
`;

export const AccordionContent = styled.div`
  margin: 0;
  padding-top: 1px;
  padding-bottom: 10px;
  height: auto;
`;

export const ArrowDown = styled.div`
  width: 0; 
  height: 0; 
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #686363;
  margin-right: 4px;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 4.17;
  letter-spacing: normal;
  color: #0f1318;
`;